import React, { useEffect, useState } from 'react';
import {
  Row, Col, Divider, Checkbox, Collapse, Menu, Popover, Pagination, Modal, Empty, Spin
} from 'antd';
import { Translation } from 'react-i18next';
import { RiChatDeleteLine, RiMailSettingsFill, RiMailOpenLine } from 'react-icons/ri';
import Footer from '../common/FooterComponent';
import utils from '../../common/utils';
import _ from 'lodash'
import { LoadingOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import consts from '../../consts'

const { Panel } = Collapse;

const noti =  {
  MENU_SYSTEM: "1",
  MENU_USER: "2",
  CHECK_ALL: "1",
  DELETE_ALL: "2",}

const dateFormat = 'DD/MM/YYYY';

export default function NotificationPage(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageUser, setCurrentPageUser] = useState(1);
  const [currentPageMark, setCurrentPageMark] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalCountUser, setTotalCountUser] = useState(0);
  const [key, setKey] = useState(noti.MENU_SYSTEM);
  const [arrKey, setArrKey] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [userNotifications, setUserNotifications] = useState([]);
  const [visible, setVisible] = useState(false)
  const [mark, setMark] = useState('')
  const [totalCountMarked, setTotalCountMarked] = useState(0)
  const [isCheckMark, setIsCheckMark] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageSize, setPageSize] = useState(consts.DEFAULT_PAGE_SIZE)

  let language = '';

  let filter = {
    pos: 0,
    count: 10,
  };

  const onChangeShowNotifications = (e) => {
    setPageSize(consts.DEFAULT_PAGE_SIZE)
    setLoading(true)
    setCurrentPageMark(1)
    setCurrentPageUser(1)
    setIsCheckMark(e.target.checked)
    if(e.target.checked){
      props.fetchMarkedNotifications(filter, updateTotalCountMarked)
    }
    else{
      props.fetchUserNotifications(filter, updateTotalCountUser)
    }
  };

  useEffect(() => {
    fetchData()
  }, [key])

  const updateTotalCountMarked = ({data, totalCount}) => {  
    setLoading(false) 
    setTotalCountMarked(totalCount)
    setArrKey([])
    setUserNotifications(data)
  };  

  const onCancel = () => {
    setVisible(false)
  }

  const fetchData = (pos = 0, count = 10) => {
    setLoading(true)
    filter = {
      ...filter,
      pos,
      count,
    };  
    switch (key) {
      case noti.MENU_SYSTEM:
        props.fetchNotifications(filter, updateTotalCount);
        break;
      case noti.MENU_USER:
        {
          isCheckMark ?
            props.fetchMarkedNotifications(filter, updateTotalCountMarked) :
            props.fetchUserNotifications(filter, updateTotalCountUser)
        }
        break;
      default:
    }
  };


  const updateTotalCount = ({data, totalCount}) => {
    setLoading(false) 
    setTotalCount(totalCount)
    setArrKey([])
    setNotifications(data)
  };

  const updateTotalCountUser = ({data, totalCount}) => {
    setLoading(false) 
    setTotalCountUser(totalCount)
    setArrKey([])
    setUserNotifications(data)
  };

  const onChangeMenu = (e) => {
    setArrKey([]);
    setKey(e.key)
    setCurrentPageMark(1)
    setCurrentPageUser(1)
  };

  const onChange = (e) => {
    let listActive = (e || []);
    if (listActive.length > 0) {
      let lastActive = _.last(listActive);
      setArrKey([_.last(listActive)]);
      onCheck(userNotifications[lastActive]);
    } else {
      setArrKey([]);
    }
  };

  const onCheck = (value) => {
    if (key === noti.MENU_USER && value.is_new) {
      let newArrCheckUser = userNotifications;
      newArrCheckUser[value.id].is_new = false;
      setUserNotifications(newArrCheckUser)
      props.checkedUserNotifications(value.created_at)
    }
  };

  const markAllAsRead = () => {
    setMark(noti.CHECK_ALL)
    setVisible(true)
  }

  const clearAllNotifications = () => {
    setTotalCountUser(0)
    setTotalCountMarked(0)
    setMark(noti.DELETE_ALL)
    setVisible(true)
  }

  const onOk = () => {
    if (mark === noti.CHECK_ALL) {
      let newArrCheckAllUser = [];
      _.map(userNotifications, (value) => {
        value.is_new = false;
        newArrCheckAllUser.push(value)
      })
      setUserNotifications(newArrCheckAllUser)
      props.checkedAllUserNotifications();
    }
    else {
      props.deleteAllUserNotifications('', () => props.fetchUserNotifications(filter, updateTotalCountUser) );
    }
    setVisible(false)
  }

  const onShowSizeChange = (page, pageSize) => {
    setCurrentPageUser(1)
    setCurrentPageMark(1)
    setLoading(true)
    setPageSize(pageSize)
    fetchData(0, pageSize);
  }

  const panelTitle = (value) => (
    <div className="noti-collapsed-header">
      <div className="d-flex align-items">
        <div className={`notification-check  ${key === noti.MENU_USER ? (value.is_new ? " notification-check-true" : "notification-check-false") : "" }`}></div>
        <div className={`notification-content ${value.is_new ? "noti-collapsed-header-true" : "noti-collapsed-header-false"}`}>{value.map_title[language]}</div>
      </div>
      <div className={`notification-time ${value.is_new ? "noti-collapsed-header-true" : "noti-collapsed-header-false"}`}>{utils.formatTimeFromUnix(value.created_at, 'DD/MM/YYYY HH:mm:ss')}</div>
    </div>
);


  return (
    <Translation>
      {(t) => {
        language = window.localStorage.getItem('LANG') ? window.localStorage.getItem('LANG') : 'vi';
        return (
          <div className="notification-page">
            <div className="noti-page-layout">
              <div className="noti-header">
                <Row>
                  <Col  span={5} className="noti-header-left">
                    <Divider orientation="left">
                      <div className="fz-24">{t('notification_page')}</div>
                    </Divider>
                  </Col>
                  <Col span={19} className="noti-header-right">
                    {
                      key === noti.MENU_USER ?
                      <Divider orientation="right">
                      <div className="fz-24 align-items d-flex">
                            <Checkbox checked={isCheckMark} onChange={onChangeShowNotifications}>{t('notify_page.hide_read_notifications')}</Checkbox>
                            <Popover onClick={markAllAsRead} className="ml-medium mr-medium styled-icon" placement="top" content={<div className="fz-14 fontW-600">{t('notify_page.mark_all_as_read')}</div>}><RiMailOpenLine /></Popover>
                            <Popover onClick={clearAllNotifications} className="styled-icon" placement="top" content={<div className="fz-14 fontW-600">{t('notify_page.clear_all')}</div>}><RiChatDeleteLine /></Popover>
                      </div>
                    </Divider> :
                    <Divider />
                    }
                  </Col>
                </Row>
              </div>
              <div className="noti-body">
                <Row gutter={16}>
                  <Col xxl={5} xl={6}>
                    <Menu
                      defaultSelectedKeys={noti.MENU_SYSTEM}
                      mode="inline"
                      className="noti-menu"
                      onClick={onChangeMenu}
                    >
                      <Menu.Item key={noti.MENU_SYSTEM} className="noti-menu-item">
                        <MailOutlined  />
                        <span>{t('notify_page.system_messages')}</span>
                      </Menu.Item>
                      <Menu.Item key={noti.MENU_USER} className="noti-menu-item">
                        <SettingOutlined />
                        <span>{t('notify_page.trade_notification')}</span>
                      </Menu.Item>
                    </Menu>
                  </Col>
                  <Col xxl={19} xl={18} className="noti-body-right">
                  <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} />} spinning={loading}>
                    <Collapse  expandIconPosition="right" bordered={false} onChange={onChange} activeKey={arrKey}>
                      {
                        window._.map(key === noti.MENU_SYSTEM ? notifications : userNotifications || [], (value, index) => (
                          <Panel header={panelTitle(value, index)} key={index}>
                            <div
                              className="noti-collapsed-content"
                              dangerouslySetInnerHTML={{ __html: value.map_content[language] }}
                            />
                            <a href={value.link} style={{ marginLeft: 18 }}>{key ===noti.MENU_SYSTEM ? value.link : t('notify_page.view_more')}</a>
                          </Panel>
                        ))
                      }
                    </Collapse>
                    </Spin>
                    {key === noti.MENU_USER && (userNotifications?.length <=0 || userNotifications === null) ? <Empty description={t('notify_page.empty')} className="noti-empty"/> : ""}
                    <div className="noti-footer-page mt-medium">
                      <Pagination
                        current={key === noti.MENU_SYSTEM ? currentPage : (isCheckMark ? currentPageMark : currentPageUser)}
                        total={key === noti.MENU_SYSTEM ? totalCount : (isCheckMark ? totalCountMarked : totalCountUser)}
                        onChange={(page, pageSize) => {
                          setLoading(true)
                          fetchData((page - 1) * pageSize, pageSize);
                          { key === noti.MENU_SYSTEM ? setCurrentPage(page) : (isCheckMark ? setCurrentPageMark(page) : setCurrentPageUser(page)) }
                        }}
                        responsive
                        hideOnSinglePage={true}
                        pageSize={pageSize}
                        showQuickJumper
                        showSizeChanger
                        pageSizeOptions={["10", "20", "50"]}
                        onShowSizeChange={onShowSizeChange}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <Modal
              visible={visible}
              onCancel={onCancel}
              okText={t('notify_page.confirm.ok')}
              cancelText={t('notify_page.confirm.cancel')}
              onOk={onOk}
            >
              <div className="fz-18" style={{color:'#000'}}>
                {mark === noti.CHECK_ALL ? t('notify_page.confirm.mark_all_as_read') : t('notify_page.confirm.clear_all')}
              </div>
            </Modal>
            <div className="footer">
              <Footer />
            </div>
          </div>
        );
      }}
    </Translation>
  );
}
